module.exports = "/images/products-icon-black.svg?b972a1e3168627f695e012ff7e097718";